import { AtomFitNav } from '../../components/design/AtomFitUI.js';
import { LandingFooter } from '../../components/landing/LandingFooter.js';
import privacyHtml from './legal/privacy.html?raw';
import termsHtml from './legal/terms.html?raw';

const pages = {
  terms: {
    title: 'Všeobecné obchodní podmínky',
    effectiveDate: 'Účinné od 1. 8. 2026',
    html: termsHtml,
  },
  privacy: {
    title: 'Informace o zpracování osobních údajů',
    effectiveDate: 'Účinné od 1. 8. 2026',
    html: privacyHtml,
  },
};

export function LegalPage({ type }: { type: keyof typeof pages }) {
  const page = pages[type];

  return (
    <main className="af-screen af-legal-page">
      <AtomFitNav />
      <article className="af-shell af-legal-shell">
        <header className="af-legal-header">
          <h1>{page.title}</h1>
          <p>{page.effectiveDate}</p>
        </header>

        <div className="af-card af-legal-card">
          <div className="af-legal-document" dangerouslySetInnerHTML={{ __html: page.html }} />
        </div>
      </article>
      <LandingFooter />
    </main>
  );
}
